<template>
  <Transition name="modal">
    <div class="mask" v-if="show" @keyup.esc="close" @click.self="close">
      <div class="content" :style="contentStyles">
        <slot></slot>
        <button type="button" class="tbutton close" v-if="closeButton" @click="close">
          <svg version="1.1" x="0px" y="0px" viewBox="0 0 100 100">
            <g transform="translate(0,-952.36218)">
              <path                
                d="m 7.96875,958.27191 a 2.000005,2.000005 0 0 0 -1.375,3.43751 l 40.59375,40.59378 -40.59375,40.5937 a 2.000005,2.000005 0 1 0 2.8125,2.8125 L 50,1005.1157 l 40.59375,40.5937 a 2.000005,2.000005 0 1 0 2.8125,-2.8125 L 52.8125,1002.3032 93.40625,961.70942 a 2.000005,2.000005 0 0 0 -1.4375,-3.43751 2.000005,2.000005 0 0 0 -1.375,0.625 L 50,999.49065 9.40625,958.89691 a 2.000005,2.000005 0 0 0 -1.4375,-0.625 z"
                fill="#404040"/>
            </g>
          </svg>
        </button>
      </div>
    </div>
  </Transition>
</template>
  
<script setup lang="ts">
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  closeButton: {
    type: Boolean,
    default: true,
  },
  contentStyles: {
    type: Object,
    // default: {
    //   backgroundColor: "#303030",
    //   color: "white"
    // }
  },
});

const emit = defineEmits(["close"]);

const close = () => {
  emit("close");
};
</script>
  
<style scoped>
.mask {
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  transition: opacity 0.3s ease;
  z-index: 1000;
}

.content {
  position: relative;
  padding: 40px 80px;
  background-color: #303030;
  max-height: calc(100vh - 80px);
  max-width: calc(100vw - 160px);
  transition: all 0.3s ease;
}

button.close {
  position: absolute;
  right: 3px;
  top: 3px;
  height: 20px;
  width: 20px;
  background-color: transparent;
  border: none;
  padding: 0px;
}

button.close:hover {
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.1);
}


/* Modal transition */
.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .content,
.modal-leave-to .content {
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
}

@media only screen and (max-width: 1900px) {
  .content {
    padding: 40px;
    max-height: calc(100vh - 80px);
    max-width: calc(100vw - 80px);
  }
}

@media screen and (max-width: 767px) {
  .content {
    padding: 20px;
    max-width: calc(100vw - 40px);
    max-height: calc(100vh - 40px);
  }
}

@media screen and (max-width: 400px) {
  .content {
    padding: 20px 10px;
    max-width: calc(100vw - 20px);
    max-height: calc(100vh - 20px);
  }

  button.close {
    right: 1px;
    top: 1px;
    height: 20px;
    width: 20px;
  }
}

@media print {
  .content {
    padding: 0px;
    height: 100vh;
    width: 100vw;
    max-width: 100vw;
    max-height: 100vh;
    overflow-y: auto;
    background-color: white;
    color: #505050;
  }
}
</style>
  